var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isQA)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v(" This is the "),_c('ocom',{attrs:{"short":""}}),_vm._v(" Testing Server. Please don't use this server for real data. Only use for Acceptance Testing as instructed by "),_c('ocom')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }